import { IconButton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import colors from "../theme/themeConstants";
import { SearchInput } from "components/UI/SearchInput";
import { HeaderButton } from "./buttons/HeaderButton";
import { toggleBurgerMenu } from "store/application/application-action";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "../store/app-state";
import { RGLogo } from "components/UI/RGLogo";
import { TABLET_WIDTH } from "hooks/useDeviceType";

import "./ApplicationHeader.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";
import CrossIcon from "./icons/Components/CrossIcon";
import { Fragment } from "react";
import AdTab from "./ads/AdTab";
import { tabs } from "./ads/config/tabs";
import { ReactComponent as RgLogo } from "./icons/RGLogo.svg";

export default function ApplicationHeader() {
  const isSearchBarOpen = useSelector((state: IAppState) => state.application.isSearchBarOpen);
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const handleBurgerMenuButton = () => {
    dispatch(toggleBurgerMenu());
  };

  const renderTopNavWrap = () => (
    <div className="topNav-wrap">
      <div>
        { isDesktop && <AdTab link={tabs.RGCams.link}>Explore <RgLogo width="18" height="12" /> Cams</AdTab> }
      </div>
      <SearchInput/>
      <div>
        { isDesktop && <AdTab link={tabs.LiveSex.link}>Watch Live Sex</AdTab> }
      </div>
      {(isDesktop || !isSearchBarOpen) && <HeaderButton onClick={handleBurgerMenuButton}/>}
    </div>
  );

  return (
    <div className="topNav">
      {location.pathname.includes(routes.create()) && !isDesktop ? (
        <Fragment>
          <p className="nav-upload">Upload</p>
          <IconButton
            sx={{
              transform: "rotate(45deg)",
              color: colors.lightGrayText,
              background: colors.lightGray_GoBackButton,
            }}
            onClick={() => navigate(-1)}
          >
            <CrossIcon/>
          </IconButton>
        </Fragment>
      ) : (
        <>
          {(isDesktop || !isSearchBarOpen) && <RGLogo />}
          {renderTopNavWrap()}
        </>
      )}
    </div>
  );
}
